// All CTAs share the .btn-micro interaction utility (index.css) — hover scale
// + glow, active press, focus ring, reduced-motion safe. variant="outline" is
// the secondary/external style (Volunteer band).
export const CtaButton = ({
  children,
  testId,
  type = "button",
  onClick,
  disabled,
  variant = "solid",
}) => {
  const classes =
    variant === "outline"
      ? "btn-micro bg-transparent text-[#16C784] border-2 border-[#16C784] font-bold px-8 py-4 rounded-full inline-flex items-center justify-center gap-2 hover:bg-[#16C784]/10 disabled:opacity-60 whitespace-nowrap"
      : "btn-micro bg-[#16C784] text-[#14171A] font-bold px-8 py-4 rounded-full shadow-md hover:bg-[#14B375] disabled:opacity-60 whitespace-nowrap";
  return (
    <button
      data-testid={testId}
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={classes}
    >
      {children}
    </button>
  );
};
